// @ts-nocheck 
/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from '@material-ui/core';
import React, { useContext, useEffect, useRef } from 'react';
import TCardContext, { ACTIONS } from '../TCardContext';
import TCardPreviewList from '../TCardPreviewList';
import { useCard } from '@dev-togetherprice/api.financial';
import Recaptcha from '@dev-togetherprice/components.recaptcha';
import StripeWrapper from '@dev-togetherprice/components.stripe-wrapper';
const useStyles = makeStyles(() => ({
    root: {
        '&, & *': {
            boxSizing: 'border-box',
        },
    },
}));
const TEST_CARD = {
    brand: 'visa',
    last4: 'xxxx',
    expMonth: 'xx',
    expYear: 'xx',
    detachable: false,
    id: 0,
};
const TCardFlow = () => {
    const classes = useStyles();
    const { dispatch, state: { testCard }, } = useContext(TCardContext);
    const { data: card, mutate } = useCard();
    const ref = useRef();
    useEffect(() => {
        dispatch({ type: ACTIONS.SET_CAPCTHA, payload: ref });
    }, [ref]);
    useEffect(() => {
        dispatch({ type: ACTIONS.SHOW_CARD_FORM, payload: !card });
        dispatch({ type: ACTIONS.SET_MUTATE, payload: mutate });
    }, [card]);
    return (React.createElement(Grid, { container: true, direction: 'column', className: classes.root },
        React.createElement(StripeWrapper, null,
            React.createElement(TCardPreviewList, { card: testCard ? TEST_CARD : card }),
            React.createElement(Recaptcha, { ref: ref }))));
};
export default TCardFlow;
